import { useEffect, useState } from 'react';
const BREAKPOINT_WIDTH_MD_PX = 767;
const NARROW_MEDIA_QUERY = `(max-width: ${BREAKPOINT_WIDTH_MD_PX}px)`;
const NARROW_PORTRAIT_MEDIA_QUERY = `(max-width: ${BREAKPOINT_WIDTH_MD_PX}px) and (orientation: portrait)`;
const getLegacyPageTabsLayout = (baseDirection)=>{
    if (typeof window == 'undefined') return {
        direction: baseDirection,
        hideText: false
    };
    const isNarrow = window.matchMedia(NARROW_MEDIA_QUERY).matches;
    const isNarrowPortrait = window.matchMedia(NARROW_PORTRAIT_MEDIA_QUERY).matches;
    return {
        direction: isNarrowPortrait ? 'horizontal' : baseDirection,
        hideText: isNarrow
    };
};
/**
 * Reproduces the mobile auto-behavior that PageTabs used to apply via SCSS media queries
 * (hide text at viewport ≤767px, flip vertical→horizontal in mobile portrait).
 *
 * TODO(ENG-337): remove once the legacy EJS profile is replaced.
 */ export const useLegacyPageTabsLayout = (baseDirection)=>{
    const [layout, setLayout] = useState(()=>getLegacyPageTabsLayout(baseDirection));
    useEffect(()=>{
        const narrowMediaQuery = window.matchMedia(NARROW_MEDIA_QUERY);
        const narrowPortraitMediaQuery = window.matchMedia(NARROW_PORTRAIT_MEDIA_QUERY);
        const update = ()=>setLayout(getLegacyPageTabsLayout(baseDirection));
        update();
        narrowMediaQuery.addEventListener('change', update);
        narrowPortraitMediaQuery.addEventListener('change', update);
        return ()=>{
            narrowMediaQuery.removeEventListener('change', update);
            narrowPortraitMediaQuery.removeEventListener('change', update);
        };
    }, [
        baseDirection
    ]);
    return layout;
};
